import TemplateView from '../../TemplateView'
import ConfigurationButton from './configurationMenu/ConfigurationButton'

export default class TaskListFilterPanel extends TemplateView {
    constructor() {
        super()
    }

    templateHtml() {
        return "<div class='taskListFiltersPanel'>" +
               "    <div class='columnsConfiguration'/>" +
               "    <div class='separator'/>" +
               "</div>"
    }

    afterRender() {
        new ConfigurationButton().init(this.find(".columnsConfiguration"))
    }
}


// WEBPACK FOOTER //
// ./web/js/taskManagement/tasksTable/TaskListFilterPanel.js